import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=b1dc704a&rel=stylesheet%2Fscss&lang=scss"

const __exports__ = script;

export default __exports__